export default __webpack_public_path__ + "static/media/prodSignIn.8fccc239.png";